export class EntityHome {
    afterAttached() {
        
    }
}